<template>
    <input type="text" v-model="proxy"  pattern="[0-9]*" inputmode="numeric"/>
</template>
<script>
export default {
    props: ['value'],
    data() {
        return {
            proxy: this.value.toFixed(3).replace('.',',')
        }
    },
    watch: {
        proxy(value, oldvalue) {            
            let valor = (value.replace(/\D+/igm,'')/1000);
            let oldvalor = (`${oldvalue}`.replace(/\D+/igm,'')/1000);
            if (valor != oldvalor) {
                this.$emit('input', valor);                
            }
            this.proxy = valor.toFixed(3).replace('.',',');
        },
        value: {
            immediate: true,
            handler(value) {
                this.proxy = value.toFixed(3).replace('.',',');
            }
        }
    }
}
</script>